<template>
  <div>
    <v-bottom-sheet class="sheet" v-model="sheet" v-show="!popupComplete">
      <v-sheet class="sheet_body text-center" color="#277FAF" height="190px">
        <CheckMark v-if="!showError"/>
        <CrossMark v-else />
        <div class="text">
          {{ message }}
          <span>{{
              localStorage.translations.pages.common.notifications.window_closes_automatically
            }}</span>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <TemplateModal ref="modal" empty external-activator v-show="popupComplete">
      <div class="dialogBody">
        <svg
          width="210"
          height="272"
          viewBox="0 0 210 272"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M150.5 4.95898C120.378 4.95898 95.9585 29.3788 95.9585 59.5007C95.9585 89.6225 120.378 114.042 150.5 114.042C180.622 114.042 205.042 89.6225 205.042 59.5007C205.042 29.3788 180.622 4.95898 150.5 4.95898ZM174.142 50.2782C174.577 49.7806 174.908 49.2009 175.116 48.5733C175.324 47.9457 175.405 47.2829 175.353 46.6238C175.301 45.9647 175.117 45.3226 174.814 44.7354C174.51 44.1481 174.092 43.6276 173.584 43.2043C173.076 42.781 172.489 42.4636 171.856 42.2708C171.224 42.0779 170.559 42.0134 169.902 42.0812C169.244 42.1489 168.606 42.3475 168.027 42.6653C167.447 42.9831 166.936 43.4136 166.526 43.9315L145.205 69.5115L134.172 58.4743C133.237 57.5711 131.985 57.0713 130.685 57.0826C129.385 57.0939 128.141 57.6154 127.222 58.5347C126.302 59.454 125.781 60.6976 125.77 61.9977C125.758 63.2977 126.258 64.5502 127.161 65.4854L142.036 80.3604C142.523 80.8473 143.107 81.2273 143.749 81.4763C144.391 81.7253 145.078 81.8377 145.766 81.8065C146.454 81.7752 147.128 81.6009 147.745 81.2948C148.362 80.9886 148.909 80.5572 149.35 80.0282L174.142 50.2782Z"
            fill="#277FAF"
          />
          <path
            d="M80.799 257.758C80.799 257.758 79.9596 262.498 79.5471 267.206C79.5103 267.641 79.5622 268.08 79.6996 268.495C79.837 268.91 80.0571 269.293 80.3466 269.621C80.6362 269.948 80.9892 270.214 81.3843 270.402C81.7795 270.59 82.2086 270.696 82.6458 270.713C88.9125 270.976 102.315 271.483 107.121 271.268C107.291 271.26 107.456 271.212 107.603 271.127C107.75 271.042 107.874 270.923 107.966 270.78C108.057 270.637 108.112 270.474 108.127 270.305C108.142 270.136 108.117 269.966 108.052 269.809C107.826 269.247 107.394 268.792 106.844 268.537L84.7079 258.374L80.799 257.758Z"
            fill="#16558F"
          />
          <path
            d="M80.1094 254.969L80.7846 260.646C80.7846 260.646 84.6607 262.451 87.3104 260.42L85.7009 254.09L80.1094 254.969Z"
            fill="url(#paint0_linear_3013:3499)"
          />
          <path
            d="M80.6168 148.188C80.3249 149.672 79.0547 222.21 86.8215 254.706C86.8868 254.963 86.8569 255.234 86.7375 255.47C86.618 255.706 86.4171 255.891 86.1718 255.99C84.1564 256.772 82.0224 257.206 79.8613 257.273C79.4398 257.288 79.0256 257.162 78.6839 256.915C78.3422 256.668 78.0925 256.314 77.9744 255.91C75.7553 248.369 65.1271 210.585 63.7402 174.489C62.189 134.16 63.7402 173.118 63.7402 173.118L64.649 148.188H80.6168Z"
            fill="#343434"
          />
          <path
            d="M55.3307 260.234C55.3307 260.234 53.9948 262.63 52.7028 268.986C52.6461 269.257 52.6473 269.537 52.7062 269.808C52.7651 270.079 52.8804 270.334 53.0446 270.557C53.2089 270.78 53.4184 270.967 53.6594 271.104C53.9005 271.241 54.1677 271.325 54.4437 271.352C56.5095 271.556 59.6958 271.819 62.247 271.801C62.5238 271.8 62.7973 271.741 63.0497 271.627C63.3021 271.514 63.5278 271.349 63.712 271.142C63.8962 270.936 64.0348 270.693 64.1188 270.429C64.2029 270.166 64.2304 269.888 64.1996 269.613C63.915 267.287 63.0354 263.472 60.3163 260.497L55.3307 260.234Z"
            fill="#16558F"
          />
          <path
            d="M54.1592 252.931L55.7359 261.518C55.7359 261.518 57.2944 262.678 60.3748 261.836L59.6229 252.596L54.1592 252.931Z"
            fill="url(#paint1_linear_3013:3499)"
          />
          <path
            d="M20.4487 163.729L23.0722 157.649C25.9067 149.976 29.3238 145.6 32 138.6C30.7072 137.669 30.6753 138.232 29.3238 137.119C27.6479 135.762 26.1058 134.414 24.6994 133.099C21.0784 140.42 18.1825 154.629 18.1825 154.629C18.3096 160.354 20.3136 158.015 20.4487 163.729Z"
            fill="url(#paint2_linear_3013:3499)"
          />
          <path
            d="M1.88428 167.938C2.41423 168.307 3.02021 168.552 3.65739 168.655C4.29458 168.758 4.94666 168.716 5.56542 168.533L17.7932 164.925C17.7932 164.925 18.8744 166.004 17.4166 168.476C15.9588 170.948 18.3122 172.909 18.3122 172.909C18.3122 172.909 20.1499 169.316 22.6955 163.932C24.1577 160.844 23.8354 157.697 23.3116 155.54L18.4486 154.297C11.361 157.095 5.32745 161.351 0.0347687 166.645L1.88428 167.938Z"
            fill="url(#paint3_linear_3013:3499)"
          />
          <path
            d="M49.8999 150.402C43.5529 188.689 51.2795 244.986 53.8818 256.005C53.9591 256.336 54.1323 256.636 54.3797 256.868C54.6271 257.1 54.9377 257.254 55.2724 257.311C56.9217 257.606 58.6154 257.538 60.2361 257.114C60.5547 257.021 60.8357 256.829 61.0395 256.568C61.2432 256.306 61.3593 255.987 61.3712 255.655C61.7362 246.743 61.0902 192.04 67.0028 170.42C67.3019 169.325 67.9728 168.367 68.9007 167.711L80.3793 159.558L81.2589 146.391L49.8999 150.402Z"
            fill="#313131"
          />
          <path
            d="M106.41 95.8652C105.442 102.72 104.424 104.296 103.632 104.336C101.114 104.467 101.621 89.0209 92.4091 81.1921C86.5913 76.2548 78.642 75.8464 72.4082 76.4226L81.1349 107.698C82.4086 110.812 87.9454 123.41 100.479 127.232C103.034 128.012 106.829 129.171 110.362 127.655C117.334 124.661 120.604 112.391 117.487 97.0247C116.02 96.4814 113.99 95.9053 106.41 95.8652Z"
            fill="#16558F"
          />
          <path
            d="M37.5619 82.5712C28.97 91.076 29.5 104.1 28.1259 106.499C26.0838 112.699 20.9886 136.668 20 142.6C21.5 146.1 26.6667 146.933 29.5 146.1L35 131.1C40.5 118.1 46.466 107.801 47.5 104.6L57.1436 76.2989C50.884 76.1971 42.9886 77.2071 37.5619 82.5712Z"
            fill="#16558F"
          />
          <path
            d="M104.187 69.1289L105.34 75.6487C107.194 83.6161 107.37 90.2598 106.41 95.868C108.001 95.9336 109.673 96.0467 111.414 96.2327C113.56 96.4441 115.589 96.7213 117.487 97.0458C116.483 88.9398 111.085 75.481 111.085 75.481C107.83 70.7698 107.443 73.8255 104.187 69.1289Z"
            fill="url(#paint4_linear_3013:3499)"
          />
          <path
            d="M117.374 55.4018C116.728 55.3854 116.088 55.5143 115.499 55.7787C114.91 56.0432 114.388 56.4365 113.972 56.9296L105.745 66.6692C105.745 66.6692 104.249 66.3629 104.107 63.4968C103.964 60.6307 100.92 60.288 100.92 60.288C100.92 60.288 101.362 64.299 102.198 70.1953C102.676 73.5791 104.676 76.0295 106.3 77.5428L111.045 75.9055C115.425 69.6702 118.122 62.7967 119.629 55.4638L117.374 55.4018Z"
            fill="url(#paint5_linear_3013:3499)"
          />
          <path
            d="M39.8301 81.9002C40.3812 81.758 44.4338 78.2054 44.9995 78.0996C54.2335 76.3384 76.9813 69.8197 92.409 81.1928C92.4491 81.521 92.4747 81.7835 92.4893 81.9987C92.7276 82.3472 92.9398 82.7129 93.1243 83.0926C94.6028 85.9571 96.3465 88.6771 98.3326 91.2168C97.8874 91.656 97.5241 92.1709 97.2596 92.7373C93.5514 100.672 79.496 132.359 81.9669 151.74C82.0004 151.977 81.9867 152.219 81.9267 152.451C81.8667 152.683 81.7614 152.901 81.617 153.092C81.4726 153.283 81.2919 153.444 81.0851 153.566C80.8784 153.687 80.6497 153.767 80.4121 153.8C74.9557 154.555 58.7104 156.393 50.3159 152.929C50.0776 152.83 49.8744 152.662 49.7326 152.447C49.5907 152.232 49.5167 151.979 49.5203 151.722C49.575 147.831 49.4108 130.959 43.2207 110.619C42.989 109.861 42.7989 109.09 42.6514 108.311C42.5747 108.468 42.5017 108.625 42.4287 108.782L39.8301 81.9002Z"
            fill="#16558F"
          />
          <path
            d="M65.6961 59.3691C62.7434 65.2472 61.5134 71.2346 61.1411 76.8063C61.7762 77.0433 70.2656 82.914 75.9191 77.2292C74.7074 73.3312 74.9081 67.4605 75.2147 61.4366L65.6961 59.3691Z"
            fill="url(#paint6_linear_3013:3499)"
          />
          <path
            d="M81.0618 43.926C81.226 44.1885 85.4415 64.1344 85.4415 64.1344L73.9885 66.3222L67.167 48.0136C67.167 48.0136 78.3463 39.5248 81.0618 43.926Z"
            fill="url(#paint7_linear_3013:3499)"
          />
          <path
            d="M71.5542 49.6143C71.4028 49.8217 71.3008 50.0609 71.2559 50.3136C71.211 50.5664 71.2244 50.826 71.295 51.0728L74.0908 60.8488C74.1324 60.9968 74.1951 61.138 74.2769 61.2682C74.7295 61.9975 76.35 64.1853 78.5362 62.3621C80.4013 60.8342 82.1349 59.445 83.6897 59.1168C83.906 59.0709 84.1291 59.0683 84.3464 59.109C84.5636 59.1497 84.7707 59.2329 84.9556 59.3539C85.1405 59.4749 85.2996 59.6313 85.4237 59.814C85.5479 59.9968 85.6346 60.2022 85.6789 60.4186C86.323 63.4221 86.7439 66.469 86.9381 69.5346C86.9559 69.9523 86.8155 70.3614 86.5449 70.6803C86.2744 70.9993 85.8935 71.2047 85.4781 71.2557C83.2043 71.5365 78.7443 71.9521 75.0105 71.4854C74.7099 71.4474 74.4252 71.3287 74.1867 71.1418C73.9482 70.955 73.765 70.707 73.6565 70.4243C72.6747 67.8718 69.9008 60.7978 68.8095 58.9126C67.7949 57.166 65.0977 57.0019 63.8604 57.0238C63.6279 57.0277 63.3971 56.9837 63.1824 56.8947C62.9676 56.8056 62.7735 56.6733 62.6122 56.506C61.634 55.4923 60.0573 53.195 62.7253 50.7301C63.0412 50.4298 63.2271 50.0181 63.2435 49.5828C63.2599 49.1475 63.1054 48.7231 62.8129 48.4C61.7399 47.193 60.7581 45.2057 62.8129 42.9632C64.8678 40.7207 67.3861 41.1072 68.992 41.7562C69.3393 41.9007 69.724 41.9295 70.0889 41.8382C70.4538 41.7469 70.7795 41.5404 71.0177 41.2494C71.1325 41.0949 71.2862 40.9735 71.463 40.8973C71.6399 40.8211 71.8337 40.7929 72.025 40.8155C72.2401 40.8344 72.4567 40.8104 72.6624 40.7449C72.8681 40.6794 73.0587 40.5736 73.2231 40.4338C73.3875 40.294 73.5224 40.1229 73.62 39.9305C73.7176 39.7381 73.7759 39.5283 73.7915 39.3132C73.901 37.7416 74.6419 35.8636 77.3756 35.1927C82.3977 33.9602 85.1752 38.9047 85.2628 42.4855C85.3504 46.0663 79.8319 47.0764 76.6529 46.6424C74.2988 46.3288 72.4009 48.462 71.5542 49.6143Z"
            fill="#343434"
          />
          <path
            d="M70.5178 62.6423C70.5178 62.6423 69.4521 56.3304 66.9045 55.8709C64.3569 55.4115 61.7364 57.366 64.0723 60.9759C66.9811 65.4719 70.5178 62.6423 70.5178 62.6423Z"
            fill="url(#paint8_linear_3013:3499)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_3013:3499"
              x1="80.1094"
              y1="257.736"
              x2="87.3104"
              y2="257.736"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA"/>
              <stop offset="1" stop-color="#FF928E"/>
            </linearGradient>
            <linearGradient
              id="paint1_linear_3013:3499"
              x1="16858.8"
              y1="8800.28"
              x2="16964.6"
              y2="8800.28"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA"/>
              <stop offset="1" stop-color="#FF928E"/>
            </linearGradient>
            <linearGradient
              id="paint2_linear_3013:3499"
              x1="68706.6"
              y1="-143198"
              x2="71004.6"
              y2="-149408"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA"/>
              <stop offset="1" stop-color="#FF928E"/>
            </linearGradient>
            <linearGradient
              id="paint3_linear_3013:3499"
              x1="123931"
              y1="-168909"
              x2="124506"
              y2="-176297"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA"/>
              <stop offset="1" stop-color="#FF928E"/>
            </linearGradient>
            <linearGradient
              id="paint4_linear_3013:3499"
              x1="21609.2"
              y1="157575"
              x2="23106.3"
              y2="164025"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA"/>
              <stop offset="1" stop-color="#FF928E"/>
            </linearGradient>
            <linearGradient
              id="paint5_linear_3013:3499"
              x1="-10364.6"
              y1="209424"
              x2="-6780.84"
              y2="215911"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA"/>
              <stop offset="1" stop-color="#FF928E"/>
            </linearGradient>
            <linearGradient
              id="paint6_linear_3013:3499"
              x1="-85489.9"
              y1="-2913.7"
              x2="-87302.2"
              y2="-87.7816"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA"/>
              <stop offset="1" stop-color="#FF928E"/>
            </linearGradient>
            <linearGradient
              id="paint7_linear_3013:3499"
              x1="67567.9"
              y1="7348.54"
              x2="70525.2"
              y2="7420.84"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA"/>
              <stop offset="1" stop-color="#FF928E"/>
            </linearGradient>
            <linearGradient
              id="paint8_linear_3013:3499"
              x1="25627.5"
              y1="1090.47"
              x2="26775.5"
              y2="1204.59"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FEBBBA"/>
              <stop offset="1" stop-color="#FF928E"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
    </TemplateModal>
    <TemplateModal
      ref="errorDescription"
      empty
      external-activator
      center
      :text="{ title: { create: modal.title} }"
    >
      <template v-for="(item, i) in modal.data">
        <v-card
          v-if="item.route"
          :key="i"
          :to="item.route"
          target="_blank"
          class="pa-3 my-3 card-btn"
          width="100%"
          color="#277FAF"
          dark
        >
          <div v-html="item.text" />
        </v-card>
      </template>
    </TemplateModal>
  </div>
</template>

<script>
import CheckMark from 'components/icons/CheckMark.vue'
import CrossMark from 'components/icons/CrossMark.vue'
import {mapGetters, mapMutations} from 'vuex'
import TemplateModal from 'components/templates/TemplateModal'

export default {
  name: 'Greeting',
  components: {
    CheckMark,
    CrossMark,
    TemplateModal,
  },
  data() {
    return {
      sheet: false,
      dialog: false,
      modal: {
        title: '',
        data: [],
      }
    }
  },
  watch: {
    showGreeting() {
      if (!this.popupComplete) {
        this.sheet = this.showGreeting
      } else {
        this.dialog = this.showGreeting
      }
    },
    dialog() {
      this.checkModalStatus()
    },
    modalData() {
      if (this.modalData && this.modalData.data && this.modalData.data.length > 0) {
        this.modal.data = []
        this.modal.title = this.modalData.title || ''
        this.modal.data = this.modal.data.concat(this.modalData.data)
        this.$refs.errorDescription.openModal()
      }
    },
  },
  mounted() {
    this.checkModalStatus()
  },
  computed: {
    ...mapGetters('popup', ['showMessage', 'modalData', 'showGreeting', 'showError', 'popupComplete']),
    message() {
      return this.showMessage
        ? this.showMessage
        : this.localStorage.translations.pages.common.notifications[this.showError
          ? 'oshibka'
          : 'izmeneniya-uspeshno-sohraneny']
    }
  },
  methods: {
    ...mapMutations('popup', ['setShowGreeting']),
    close() {
      this.setShowGreeting(false)
    },
    checkModalStatus() {
      if (this.dialog) {
        this.$refs.modal && this.$refs.modal.openModal()
      } else {
        if (this.$refs.modal && this.$refs.modal.dialog) {
          this.$refs.modal.closeModal()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.card-btn {
  border-radius: 15px !important;
  box-shadow: none !important;
  border: 1px solid #277FAF !important;
  &:hover {
    filter: brightness(85%);
  }
}

.sheet {
  display: flex;
  align-items: center;

  &_body {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    justify-items: center;
    flex-direction: column;

    .text {
      margin: 20px auto 12px;
      font-size: 24px;
      font-weight: bold;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: #ffffff;
      display: grid;
      white-space: pre-line;

      span {
        margin-top: 10px;
        text-transform: none;
        font-size: 14px;
        font-weight: 300;
      }
    }
  }
}

.dialogBody:deep() {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
